/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecuteDocumentResponse {
    getFixupPrototypeFunction() { return AwsSsmExecuteDocumentResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecuteDocumentResponse>): AwsSsmExecuteDocumentResponse {
        let obj = Object.assign(new AwsSsmExecuteDocumentResponse(), model);
        AwsSsmExecuteDocumentResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecuteDocumentResponse>): AwsSsmExecuteDocumentResponse {
        if (!model) return null;
        return AwsSsmExecuteDocumentResponse.newInstance(<AwsSsmExecuteDocumentResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecuteDocumentResponse) {
        if (!obj) return;

        models.AwsSsmExecuteDocumentResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecuteDocumentResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecuteDocumentResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Automation Execution Id
     */
    execution_id: string;

}
